<template>
  <div class="row">
    <div class="col-md-12 animated fade-in">
      <card header-text="Companies">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group">
              <input
                type="text"
                v-model="searchParams.companyname"
                class="form-control"
                name="companyname"
                placeholder="Search by BSE code/company"
                @keyup="search"
              >
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group">
              <!-- <input type="text" v-model="searchParams.sectorname" class="form-control" name="sector" placeholder="Search by Sector"/> -->
              <select class="form-control" name="sector" v-model="searchParams.sectorname">
                <option value>Select Sector</option>
                <option
                  v-for="(sec, index) in sectorData"
                  :value="sec.sect_name"
                  v-bind:key="sec.sect_code+index"
                >{{sec.sect_name}}</option>
              </select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-2">
                <div class="form-group" style="margin-top: 3px;">
                  <button type="button" class="btn btn-sm btn-primary" @click="search">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group" style="margin-top: 3px;">
                  <button type="button" class="btn btn-sm btn-success" @click="reset">
                    <i class="fa fa-refresh"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-responsive">
          <!-- <vtable :apiUrl="apiUrl" :fields="tableFields" :actions="actions" ref="search"/> -->
          <div class="table-responsive app">
            <table class="table table-sm first-td-padding table-bordered">
              <thead>
                <tr>
                  <th>Sr.</th>
                  <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
                  <th v-if="actions">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row,index) in fillableData" v-bind:key="'row'+index">
                  <td>{{index+1}}</td>
                  <td v-for="(field, ind) in tableFields" v-bind:key="field.name+index+ind">{{row[field.name]}}</td>
                  <td v-if="actions">
                    <div class="action-btn-wrapper">
                      <a
                        style="margin:1px 4px"
                        class="btn btn-sm btn-small"
                        :class="action.btnClass"
                        v-for="action in actions"
                        v-bind:key="'action'+action.tooltip"
                        @click.prevent="action.callback(row,index,$event)"
                      >
                        <i :title="action.tooltip" class="fa" :class="action.icon"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tfoot v-if="fillableData.length==0">
                <tr>
                  <td :colspan="(tableFields.length+actions.length)">
                    <i class="fa fa-info cwhite"></i> No data found.
                  </td>
                </tr>
              </tfoot>
            </table>
            <div class="pull-right" v-if="searchParams.sectorname == '' && searchParams.companyname == ''">
              <ul v-if="this.totalPages != 1" class="pagination">
                <li :class="{disabled:prevDisabled}" class="page-item">
                  <a class="page-link" @click.prevent="goToPage(1)" href="#">{{'&lt;&lt;'}}</a>
                </li>
                <li :class="{disabled:prevDisabled}" class="page-item">
                  <a class="page-link" @click.prevent="prev()" href="#">{{'&lt;'}}</a>
                </li>
                <li
                  v-for="page in pages"
                  v-bind:key="page"
                  class="page-item"
                  :class="(current_page == page)? 'active':''"
                >
                  <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
                </li>
                <li :class="{disabled:nextDisabled}" class="page-item">
                  <a class="page-link" href="#" @click.prevent="next()">{{'&gt;'}}</a>
                </li>
                <li :class="{disabled:nextDisabled}" class="page-item">
                  <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">{{'&gt;&gt;'}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import vtable from "@/components/vtable";
import http from "@/lib/http";
import VueJwtDecode from 'vue-jwt-decode'
// import companyDetails from './companyDetails'
export default {
  name: "Company",
  components: {
    vtable
  },
  created() {
    console.log("Config ", process.env.API_URL);    
    this.url = this.apiUrl;
    console.log(this.url.indexOf("companiesListing"), this.$route.query);
    // if (this.url.indexOf("companiesListing") != -1) this.url += this.pageToLoad;
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "1");
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    console.log("this.searchParams", this.searchParams);
    if( localStorage.getItem('secC')){
      this.searchParams.sectorname = localStorage.getItem('secC');
    };
    this.fetchData(this.searchParams);
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      apiUrl: "companiesListing/page/",
      apiMode: true,
      company: {},
      actions: [
        {
          btnClass: "btn-success",
          icon: "fa-eye cwhite",
          callback: this.showDetailView,
          tooltip: "View Details"
        },
        // {
        //   btnClass: "btn-info",
        //   icon: "fa-list cwhite",
        //   callback: this.viewRawData,
        //   tooltip: "Raw Data"
        // },
        {
          btnClass: "btn-warning",
          icon: "fa-calculator cwhite",
          callback: this.viewCalculatedData,
          tooltip: "Calculated Data"
        },
        {
          btnClass: "btn-primary",
          icon: "fa-edit cwhite",
          callback: this.editCompany,
          tooltip: "Edit"
        }
      ],
      tableFields: [
        {
          name: "bsecode",
          title: "BSE Code"
        },
        // {
        //   name: "co_code",
        //   title: "Company Code"
        // },
        {
          name: "companyname",
          title: "Full name"
        },
        {
          name: "sectorname",
          title: "Sector Name"
        }
      ],
      // itemsPerPage: ItemsPerPageDef.itemsPerPage,
      // sortFunctions: FieldsDef.sortFunctions,
      paginationPath: "",
      searchParams: { companyname: "", sectorname: "" },
      sectorData: [],
      fillableData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: []
    };
  },
  methods: {
    showDetailView(row) {
      console.log("view clicked", row);
      localStorage.setItem("selcomp", JSON.stringify({companyname: row.companyname, co_code: row.co_code}));
      // http.post("final_data", { co_code: row.co_code }, (error, response) => {
      //   // console.log("RawData", response);
      //   localStorage.setItem("selcomp", JSON.stringify({companyname: row.companyname, co_code: row.co_code}));
      //   let company = response.data.length > 0 ? response.data[0] : [];
        this.$router.push({
          name: "viewcompany",
          params: { company: {} }
        // });
        //TODO:: add company updates into our array in future
      });
    },
    editCompany(row) {
      console.log("editing row", row);
      http.post("final_data", { co_code: row.co_code }, (error, response) => {
        // console.log("RawData", response);
        localStorage.setItem("selcomp", JSON.stringify({companyname: row.companyname, co_code: row.co_code}));
        setTimeout(() => {
          this.$router.push({
            name: "editcompany",
            params: { company: response.data[0], isFromComp: 1 },
            // query: Object.assign({}, this.$route.query, { id: row.co_code })
          });
        }, 200);
        //TODO:: add company updates into our array in future
      });
    },
    viewCalculatedData(row) {
      localStorage.setItem("selcomp", JSON.stringify({companyname: row.companyname, co_code: row.co_code}));
      this.$router.push({ name: "calculateddata", params: { company: row } });
      //`rawdata/${row}`
    },
    viewRawData(row) {
      this.$router.push({ name: "rawdata", params: { company: row } });
      //`rawdata/${row}`
    },
    search() {
      console.log(this.searchParams);
      if (
        this.searchParams.companyname.length > 2 ||
        this.searchParams.sectorname != ""
      ) {
        if(this.searchParams.sectorname != ""){
          localStorage.setItem('secC', this.searchParams.sectorname);
        }
        this.fetchData(this.searchParams);
      }
      if (
        this.searchParams.companyname.length == 0 &&
        this.searchParams.sectorname == ""
      ) {
        console.log("Reset");
        this.reset();
      } else{
        console.log("Not Reset");
      }
      // this.$refs.search.searchIn(this.searchParams);
    },
    getSectorData() {
      let _this = this;
      // this.axios.get("getSectorList", {}, {headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}}).then((response) => {
      http.get("getSectorList", {}, function(error, response) {
        console.log("Sector Data", response);
        _this.sectorData = response;
      });
    },
    reset() {
      // window.location.reload();
      this.$router.push({ name: "companies" });
      localStorage.removeItem('secC');
      this.searchParams = { companyname: "", sectorname: "" };
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = data
          ? { companyname: data.companyname, sectorname: data.sectorname }
          : {};
        http.post(this.url, params, function(error, response) {
        //  this.axios.post(this.url, params,  {headers: {Authorization: 'Bearer ' + localStorage.getItem('token')}}).then((response) => {
          console.log(response);
          if (!error) {
            myself.fillableData = response.data;
            myself.current_page = myself.pageToLoad;
            myself.totalPages = response.total_pages;
            myself.prevDisabled = myself.pageToLoad == 1;
            myself.nextDisabled = myself.current_page == myself.totalPages;
            myself.isLoading = false;
            // set 5 pages to show
            console.log("current", myself.current_page);
            let i = 5;
            let page = myself.current_page - 2;
            if (page <= 0) page = 1;
            myself.pages = [];
            while (i) {
              myself.pages.push(parseInt(page));
              if (myself.totalPages <= page) break;
              page++;
              i--;
            }
            myself.getSectorData();
            console.log("PAges", myself.pages);
          } else {
            console.log(error);
          }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/company/Company.vue